import { Link } from "react-router-dom";

const HERO_IMG =
  "https://images.pexels.com/photos/34770978/pexels-photo-34770978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1600&w=2400";

const MOTTO = [
  "Reaching Souls",
  "Rooting Disciples",
  "Releasing Destiny",
  "Strengthening Families",
  "Reforming Culture",
];

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex flex-col justify-end overflow-hidden grain"
    >
      <img
        src={HERO_IMG}
        alt="RE//FORM PLACE CHI worship gathering"
        className="absolute inset-0 w-full h-full object-cover hero-image"
        loading="eager"
        fetchPriority="high"
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,10,10,0.35) 0%, rgba(10,10,10,0.72) 60%, rgba(10,10,10,0.95) 100%)",
        }}
      />

      <div className="relative z-10 container-x pb-32 md:pb-40 pt-40">
        <p
          className="eyebrow mb-6"
          data-testid="hero-eyebrow"
        >
          Chicago · Apostolic · Prophetic
        </p>
        <h1
          data-testid="hero-title"
          className="font-display font-black uppercase leading-[0.9] tracking-tight text-white text-[64px] sm:text-[92px] md:text-[128px] lg:text-[168px]"
        >
          RE<span className="brand-red">//</span>FORM
          <br />
          <span className="brand-red">PLACE</span> CHI
        </h1>
        <p
          data-testid="hero-tagline"
          className="mt-6 font-display uppercase tracking-widest text-white/80 text-lg md:text-2xl max-w-2xl leading-tight"
        >
          A Safe Place to Become.
          <br className="hidden md:block" />{" "}
          <span className="text-white/60">A Strong Place to Belong.</span>
        </p>
        <p
          data-testid="hero-sub"
          className="mt-6 text-sm md:text-base text-white/60 leading-relaxed max-w-xl"
        >
          A Spirit-filled community in Chicago committed to reaching souls,
          rooting disciples, releasing destiny, strengthening families, and
          reforming culture.
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/new-here"
            data-testid="hero-cta-visit"
            className="btn-primary-sharp"
          >
            Plan Your Visit
          </Link>
          <Link
            to="/watch"
            data-testid="hero-cta-watch"
            className="btn-outline-sharp"
          >
            Watch Online
          </Link>
        </div>
      </div>

      {/* Editorial ribbon */}
      <div className="relative z-10 bg-[var(--brand-red)] py-3 border-t border-black/20">
        <div className="marquee">
          <div className="marquee-track">
            {[...Array(2)].map((_, i) => (
              <div key={i} className="flex items-center gap-12 pr-12">
                {MOTTO.map((m) => (
                  <span
                    key={m + i}
                    className="font-display font-bold uppercase tracking-[0.32em] text-white/95 text-xs md:text-sm"
                  >
                    {m}
                    <span className="ml-12 text-white/40">//</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
